import React, {PureComponent} from "react";
import withStyles from '@mui/styles/withStyles';
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import PlayArrowIcon from '@mui/icons-material/PlayArrow';
import Avatar from "@mui/material/Avatar";
import moment from "moment";
import {UrlBuilder} from "../../core/url/UrlBuilder";
import Button from "@mui/material/Button";
import StopIcon from '@mui/icons-material/Stop';
import InfoIcon from '@mui/icons-material/Info';
import {green, red} from "@mui/material/colors";
import IconButton from "@mui/material/IconButton";
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import CircularProgress from "@mui/material/CircularProgress";
import {UserContext} from "../../core/UserContext";
import {Dialog, ListItemIcon, ListItemText, Menu, MenuItem, Popover} from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import CardContent from "@mui/material/CardContent";
import Grid from "@mui/material/Grid";
import {LocalizationProvider, StaticDateTimePicker} from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import Backdrop from "@mui/material/Backdrop";
import Fade from "@mui/material/Fade";
import TextField from "@mui/material/TextField";
import HistoryToggleOffIcon from '@mui/icons-material/HistoryToggleOff';
import Box from "@mui/material/Box";

const useStyles = theme => ({
	grow: {
		flexGrow: 1,
	},
	popOverText: {
		padding: theme.spacing(2),
	},
});

class WorkoutCallToAction extends PureComponent {

	constructor(props) {
		super(props);
		this.state = {
			isLoading: false,
			dropDownMenuAnchorEl: null,
			dropDownStartDateOverwriteAnchorEl: null,
			startDateOverwrite: null,
			startDateOverwriteTooltipAnchorEl: null,
		};
	}

	startWorkout = async (event, startDateOverwrite = null) => {
		event.preventDefault();

		this.setState({
			isLoading: true,
		});

		let workout = {
			dateTimeStarted: startDateOverwrite ? moment(startDateOverwrite).format('L, h:mm:ss A') : moment().format('L, h:mm:ss A'),
			isPastWorkout: !!startDateOverwrite,
		};

		let res = await fetch(UrlBuilder.workout.startWorkoutApi(), {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(workout)
		}).then(res => res.json());

		this.context.setUser(res.data);

		this.setState({
			workout: res.data,
			isLoading: false,
			dropDownStartDateOverwriteAnchorEl: null,
		});
	}

	finishWorkout = async () => {
		this.setState({
			isLoading: true,
		});

		const response = await fetch(
			UrlBuilder.workout.currentWorkoutApi()
		).then(res => res.json());
		const fetchedWorkout = response.data;

		if (fetchedWorkout && fetchedWorkout.routines.length > 0) {
			this.setState({
				isLoading: false,
			});
			this.context.openActiveWorkoutBloop(true);
			return;
		}

		let workout = {
			dateTimeEnded: moment().format('L, h:mm:ss A')
		};

		const res = await fetch(UrlBuilder.workout.finishWorkoutApi(), {
			method: 'POST',
			headers: {
				'Accept': 'application/json',
				'Content-Type': 'application/json'
			},
			body: JSON.stringify(workout)
		}).then(res => res.json());

		this.context.setUser(res['data']);

		this.setState({
			isLoading: false,
		});
	}

	openDropdownMenu = (event) => {
		event.stopPropagation();
		this.setState({
			dropDownMenuAnchorEl: event.currentTarget,
		});
	};

	closeDropdownMenu = (event) => {
		event.stopPropagation();
		this.setState({
			dropDownMenuAnchorEl: null
		});
	};

	openDropDownStartDateOverwriteAnchorEl = (event) => {
		this.setState({
			dropDownStartDateOverwriteAnchorEl: event.currentTarget,
			dropDownMenuAnchorEl: null,
		});
	};

	closeDropDownStartDateOverwriteAnchorEl = () => {
		this.setState({
			dropDownStartDateOverwriteAnchorEl: null
		});
	};

	openStartDateOverwriteTooltip = (event) => {
		this.setState({
			startDateOverwriteTooltipAnchorEl: event?.currentTarget ?? null,
		});
	}

	setStartDateOverwrite = (dateString) => {
		this.setState({
			startDateOverwrite: dateString
		});
	}

	renderStartPastWorkoutDialog = () => {
		const {classes} = this.props;

		return <Dialog
			open={this.state.dropDownStartDateOverwriteAnchorEl !== null}
			anchorEl={this.state.dropDownStartDateOverwriteAnchorEl}
			onClose={this.closeDropDownStartDateOverwriteAnchorEl}
			BackdropComponent={Backdrop}
			BackdropProps={{
				timeout: 500,
			}}
		>
			<AppBar style={{ position: 'relative'}} enableColorOnDark>
				<Toolbar variant='dense'>
					<Typography variant="h6" noWrap className={classes.title}>
						Select a Workout Start Date
					</Typography>

					<div className={classes.grow}/>

					<IconButton size='small' onClick={this.openStartDateOverwriteTooltip}>
						<InfoIcon/>
					</IconButton>
					<Popover
						open={this.state.startDateOverwriteTooltipAnchorEl !== null}
						anchorEl={this.state.startDateOverwriteTooltipAnchorEl}
						onClose={() => this.openStartDateOverwriteTooltip(null)}
						anchorOrigin={{
							vertical: 'bottom',
							horizontal: 'center',
						}}
						transformOrigin={{
							vertical: 'top',
							horizontal: 'center',
						}}
					>
						<Typography className={classes.popOverText}>You can start a workout with a date and time from the past. This can be used to log previous workouts you did not get to log in real-time.</Typography>
					</Popover>
				</Toolbar>
			</AppBar>
			<Card>
				<CardContent>
					<LocalizationProvider dateAdapter={AdapterDateFns}>
					<StaticDateTimePicker
							label='Pick a Date and Time'
							disableFuture
							value={this.state.startDateOverwrite ? new Date(this.state.startDateOverwrite) : new Date()}
							onChange={this.setStartDateOverwrite}
							renderInput={(params) => <TextField {...params} />}
						/>
					</LocalizationProvider>
				</CardContent>
				<Grid container alignItems='center' justify="center" direction="column" style={{marginBottom: 14}}>
					<Grid xs item>
						<Button
							variant="contained"
							color='primary'
							disabled={this.state.startDateOverwrite ? moment(this.state.startDateOverwrite).isAfter(moment()) : false}
							onClick={(e) => this.startWorkout(e, this.state.startDateOverwrite)}
						>
							Start Workout
						</Button>
					</Grid>
				</Grid>
			</Card>
		</Dialog>;
	}

	render() {
		const {classes} = this.props;

		let activeWorkout = this.context.user?.activeWorkout;

		if (!activeWorkout) {
			return (
				<Card variant="outlined" sx={{ borderRadius: 2.5, bgcolor: (theme) => theme.palette.secondary.startWorkoutColor }}>
					<Box sx={{
						display: 'flex',
						alignItems: 'center',
						px: 2,
						py: 1.5,
					}}>
						<Avatar
							onClick={this.state.isLoading ? undefined : this.startWorkout}
							sx={{
								bgcolor: green[500],
								width: 44,
								height: 44,
								mr: 1.5,
								cursor: this.state.isLoading ? 'default' : 'pointer',
							}}
						>
							{this.state.isLoading ?
								<CircularProgress size={24} color="inherit" />
								:
								<PlayArrowIcon />
							}
						</Avatar>

						<Box
							onClick={this.state.isLoading ? undefined : this.startWorkout}
							sx={{ flex: 1, cursor: this.state.isLoading ? 'default' : 'pointer' }}
						>
							<Typography variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
								Start Workout
							</Typography>
							<Typography variant="caption" sx={{ color: 'text.secondary' }}>
								Begin tracking your session
							</Typography>
						</Box>

						<Button
							variant="contained"
							size="small"
							onClick={this.startWorkout}
							disabled={this.state.isLoading}
							sx={{
								bgcolor: green[500],
								'&:hover': { bgcolor: green[600] },
								textTransform: 'none',
								fontWeight: 600,
								px: 2,
								mr: 0.5,
							}}
						>
							Start
						</Button>

						<IconButton
							size="small"
							onClick={this.openDropdownMenu}
						>
							<MoreVertIcon fontSize="small" />
						</IconButton>
						<Menu
							anchorEl={this.state.dropDownMenuAnchorEl}
							open={Boolean(this.state.dropDownMenuAnchorEl)}
							onClose={this.closeDropdownMenu}
							TransitionComponent={Fade}
						>
							<MenuItem onClick={this.openDropDownStartDateOverwriteAnchorEl}>
								<ListItemIcon>
									<HistoryToggleOffIcon fontSize="small"/>
								</ListItemIcon>
								<ListItemText primary="Start Past Workout"/>
							</MenuItem>
						</Menu>

						{this.renderStartPastWorkoutDialog()}
					</Box>
				</Card>
			);
		}

		const startedAgo = moment(activeWorkout.dateTimeStarted).fromNow();

		return (
			<Card variant="outlined" sx={{ borderRadius: 2.5, bgcolor: (theme) => theme.palette.secondary.stopWorkoutColor }}>
				<Box sx={{
					display: 'flex',
					alignItems: 'center',
					px: 2,
					py: 1.5,
				}}>
					<Avatar
						onClick={this.state.isLoading ? undefined : this.finishWorkout}
						sx={{
							bgcolor: red[500],
							width: 44,
							height: 44,
							mr: 1.5,
							cursor: this.state.isLoading ? 'default' : 'pointer',
						}}
					>
						{this.state.isLoading ?
							<CircularProgress size={24} color="inherit" />
							:
							<StopIcon />
						}
					</Avatar>

					<Box
						onClick={this.state.isLoading ? undefined : this.finishWorkout}
						sx={{ flex: 1, cursor: this.state.isLoading ? 'default' : 'pointer' }}
					>
						<Typography variant="subtitle1" sx={{ fontWeight: 600, lineHeight: 1.3 }}>
							Workout in Progress
						</Typography>
						<Typography variant="caption" sx={{ color: 'text.secondary' }}>
							Started {startedAgo}
						</Typography>
					</Box>

					<Button
						variant="contained"
						size="small"
						onClick={this.finishWorkout}
						disabled={this.state.isLoading}
						sx={{
							bgcolor: red[500],
							'&:hover': { bgcolor: red[600] },
							textTransform: 'none',
							fontWeight: 600,
							px: 2,
							mr: 0.5,
						}}
					>
						Finish
					</Button>

					<IconButton
						size="small"
						onClick={() => this.context.openActiveWorkoutBloop(true)}
						disabled={this.state.isLoading}
					>
						<ExpandMoreIcon fontSize="small" />
					</IconButton>
				</Box>
			</Card>
		);
	}
}

WorkoutCallToAction.contextType = UserContext;

export default withStyles(useStyles)(WorkoutCallToAction);
